<div class="container-fluid">
  <form #mlServicesForm="ngForm">
    <div class="row pb-20">
      <div class="col-md-2 col-lg-2">
        <input type="text" class="form-control" required name="resourceGroup"
               #resourceGroup="ngModel"
               [(ngModel)]="selectedResourceGroup"
               [typeahead]="resourceGroups"
               [typeaheadOptionField]="'name'"
               (typeaheadOnSelect)="onSelectResourceGroup($event.item)"
               placeholder="Enter Resource Group Name"
               [typeaheadOptionsLimit]="5"
               autocomplete="off">
        <span class="text-danger" *ngIf="(resourceGroup.invalid && resourceGroup.touched)">
          Please select a valid resource group.
        </span>
      </div>
      <div class="col-md-2 col-lg-2">

        <input type="text" class="form-control" required name="workspace"
               #workspace="ngModel"
               [(ngModel)]="url"
               [typeahead]="workspaceList"
               [typeaheadOptionField]="'name'"
               (typeaheadOnSelect)="onSelectWorkspace($event.item)"
               placeholder="Enter Workspace Name"
               [typeaheadOptionsLimit]="5"
               autocomplete="off">
        <span class="text-danger" *ngIf="(workspace.invalid && workspace.touched)">
          Please select a valid Workspace.
        </span>
      </div>

      <div class="col-md-1 col-lg-1">
        <button class="btn btn-primary" (click)="redirectToML()" [disabled]="(!mlServicesForm.valid)">Launch</button>
      </div>

      <div class="col-md-4 col-lg-4"></div>

    </div>
  </form>
</div>
